import React, { useState } from 'react';
import { X, TrendingUp, Star, Award, Check } from 'lucide-react';
interface PromoteListingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceedToPay?: () => void;
}
export function PromoteListingModal({
  isOpen,
  onClose,
  onProceedToPay
}: PromoteListingModalProps) {
  const [selectedPlan, setSelectedPlan] = useState('featured');
  if (!isOpen) return null;
  const handleProceedToPay = () => {
    if (onProceedToPay) {
      onProceedToPay();
    } else {
      onClose();
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-668">
      <div className="bg-white w-full max-w-2xl border border-gray-300 shadow-xl relative animate-in fade-in zoom-in-95 duration-200" data-id="element-669">
        <div className="flex justify-between items-center p-6 border-b border-gray-200" data-id="element-670">
          <h2 className="text-xl font-bold flex items-center gap-2" data-id="element-671">
            <TrendingUp className="w-5 h-5" data-id="element-672" /> Promote Your Listing
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-673">
            <X className="w-5 h-5" data-id="element-674" />
          </button>
        </div>

        <div className="p-6" data-id="element-675">
          <p className="text-gray-500 mb-6" data-id="element-676">
            Boost visibility and get up to 5x more inquiries.
          </p>

          <div className="grid grid-cols-3 gap-4 mb-8" data-id="element-677">
            {/* Basic Plan */}
            <div className={`border p-4 cursor-pointer transition-all ${selectedPlan === 'basic' ? 'border-[#1f2933] bg-gray-50 ring-1 ring-[#1f2933]' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => setSelectedPlan('basic')} data-id="element-678">
              <div className="font-bold text-lg mb-1" data-id="element-679">Basic</div>
              <div className="text-2xl font-bold mb-4" data-id="element-680">
                ₹999
                <span className="text-xs font-normal text-gray-500" data-id="element-681">/week</span>
              </div>
              <ul className="space-y-2 text-xs text-gray-600 mb-4" data-id="element-682">
                <li className="flex gap-2" data-id="element-683">
                  <Check className="w-3 h-3 text-green-600" data-id="element-684" /> Standard Listing
                </li>
                <li className="flex gap-2" data-id="element-685">
                  <Check className="w-3 h-3 text-green-600" data-id="element-686" /> Email Support
                </li>
              </ul>
            </div>

            {/* Featured Plan */}
            <div className={`border p-4 cursor-pointer transition-all relative ${selectedPlan === 'featured' ? 'border-blue-600 bg-blue-50 ring-1 ring-blue-600' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => setSelectedPlan('featured')} data-id="element-687">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase" data-id="element-688">
                Most Popular
              </div>
              <div className="font-bold text-lg mb-1 flex items-center gap-2" data-id="element-689">
                Featured{' '}
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-690" />
              </div>
              <div className="text-2xl font-bold mb-4" data-id="element-691">
                ₹2,499
                <span className="text-xs font-normal text-gray-500" data-id="element-692">/week</span>
              </div>
              <ul className="space-y-2 text-xs text-gray-600 mb-4" data-id="element-693">
                <li className="flex gap-2" data-id="element-694">
                  <Check className="w-3 h-3 text-green-600" data-id="element-695" /> Top of Search
                </li>
                <li className="flex gap-2" data-id="element-696">
                  <Check className="w-3 h-3 text-green-600" data-id="element-697" /> "Featured" Badge
                </li>
                <li className="flex gap-2" data-id="element-698">
                  <Check className="w-3 h-3 text-green-600" data-id="element-699" /> 3x Visibility
                </li>
              </ul>
            </div>

            {/* Premium Plan */}
            <div className={`border p-4 cursor-pointer transition-all ${selectedPlan === 'premium' ? 'border-purple-600 bg-purple-50 ring-1 ring-purple-600' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => setSelectedPlan('premium')} data-id="element-700">
              <div className="font-bold text-lg mb-1 flex items-center gap-2" data-id="element-701">
                Premium <Award className="w-4 h-4 text-purple-600" data-id="element-702" />
              </div>
              <div className="text-2xl font-bold mb-4" data-id="element-703">
                ₹4,999
                <span className="text-xs font-normal text-gray-500" data-id="element-704">/week</span>
              </div>
              <ul className="space-y-2 text-xs text-gray-600 mb-4" data-id="element-705">
                <li className="flex gap-2" data-id="element-706">
                  <Check className="w-3 h-3 text-green-600" data-id="element-707" /> Homepage Feature
                </li>
                <li className="flex gap-2" data-id="element-708">
                  <Check className="w-3 h-3 text-green-600" data-id="element-709" /> Social Media Ad
                </li>
                <li className="flex gap-2" data-id="element-710">
                  <Check className="w-3 h-3 text-green-600" data-id="element-711" /> Dedicated Manager
                </li>
              </ul>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-6 border-t border-gray-200" data-id="element-712">
            <button onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-713">
              Cancel
            </button>
            <button onClick={handleProceedToPay} className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-714">
              Proceed to Pay
            </button>
          </div>
        </div>
      </div>
    </div>;
}